import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment/moment';

import { GetResourcesLvl2GQL } from '../../../../generated/graphql';
import { FilterInterface } from '../../../shared/filter-bar/filter-bar.component';

@Component({
  selector: 'app-interested-per-hour-matrix',
  templateUrl: './interested-per-hour-matrix.component.html',
  styleUrls: ['./interested-per-hour-matrix.component.scss']
})
export class InterestedPerHourMatrixComponent implements OnInit {
  metricGroups = [];
  initDates;
  filterCache;
  isDatePickerClosed: boolean;
  isLoading = false;

  @Input() dashboardId: string;
  @Input() dashboardTitle: string;
  @Input() cardDescription: string;
  @Input() card;

  constructor(
    private getResourcesLvl2: GetResourcesLvl2GQL,
    private dialog: MatDialog
  ) {}

  openDescription(template: TemplateRef<any>) {
    this.dialog.open(template, { autoFocus: false, maxHeight: '80dvh' });
  }

  formatInnerText(text: string): string {
    return text.replace(/\n/g, '<br>');
  }

  ngOnInit(): void {
    this.initDates = {
      dateRange: {
        dateFrom: moment().startOf('month'),
        dateTo: moment().endOf('month')
      }
    };
    this.onFilterChanges(this.initDates);
  }

  loadData(dateFrom, dateTo): void {
    if (!this.card?.id || !this.dashboardId) {
      return;
    }
    this.isLoading = true;
    this.getResourcesLvl2.fetch({
      id: this.card.id,
      dateFrom,
      dateTo,
      dashboardId: this.dashboardId
    }).subscribe(val => {
      this.metricGroups = [...val.data.metricGroupsAssignment.edges];
      this.isLoading = false;
    }, () => this.isLoading = false);
  }

  onFilterChanges(filters: FilterInterface) {
    const dateRange = filters.dateRange;
    const cachedRange = this.filterCache?.dateRange;

    this.isDatePickerClosed = !!(
      !this.filterCache || (dateRange.dateFrom.isSame(cachedRange.dateFrom) && (!cachedRange.dateTo && dateRange.dateTo))
    );

    this.filterCache = filters;

    if ((this.isDatePickerClosed) && dateRange && (dateRange.dateFrom && dateRange.dateTo)) {
      this.loadData(
        dateRange.dateFrom ? moment(dateRange.dateFrom).format('YYYY-MM-DD') : null,
        dateRange.dateTo ? moment(dateRange.dateTo).format('YYYY-MM-DD') : null
      );
    }
  }

}
